<template>
  <el-dialog :title="!dataForm.id ? '新增' : '修改'" :modal-append-to-body="false" :show-close="false"
    :close-on-click-modal="false" :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
      label-width="100px" style="margin-top: 10px;">
      <el-form-item label="设备名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item label="唯一编码" prop="uniqueCode">
        <el-input v-model="dataForm.uniqueCode" placeholder="唯一编码" :disabled="disAble"></el-input>
      </el-form-item>
      <el-form-item label="点位">
        <el-select v-model="dataForm.poiId" placeholder="请选择点位" style="width: 100%">
          <div style="position: absolute;width: 100%;background: #fff;z-index: 9999;top: 0px;">
            <el-input v-model="inputValue" placeholder="输入点位查询" clearable @input="filterMath($event)"
              style="width: 98%;margin: 5px;"></el-input>
          </div>
          <template>
            <el-option v-for="item in poiOption" :key="item.value" :label="item.label" :value="item.value" class="dianwei">
            </el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="设备型号">
        <el-select v-model="dataForm.type" filterable default-first-option allow-create placeholder="请选择型号"
          style="width: 100%" @input="handleInput">
          <el-option v-for="item in typeOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="视频监控" prop="videoUrl">
        <el-input v-model="dataForm.videoUrl" placeholder="视频监控的url"></el-input>
      </el-form-item>
      <el-form-item label="设备类型">
        <el-select v-model="dataForm.deviceType" placeholder="请选择" style="width: 100%">
          <el-option label="固定式" :value="0"></el-option>
          <el-option label="便携式" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备状态">
        <el-select v-model="dataForm.status" placeholder="请选择" style="width: 100%">
          <el-option v-for="item in enumOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="质保截止日期" style="position: relative;">
        <i
          style="width: 64px;display: inline-block;position: absolute;height: 36px;background: #fff;left: 106px;z-index: 999;top: 2px;"></i>
        <el-date-picker v-model="dataForm.warrantyTime" type="date" format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;" :picker-options="dataForm.pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="开启通知">
        <el-select v-model="dataForm.noticeEnable" placeholder="请选择" style="width: 100%">
          <el-option v-for="item in noticeOption" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开启上级推送" prop="pushParent" style="position: relative">
        <el-select v-model="dataForm.pushParent" placeholder="请选择" style="width: 100%">
          <el-option label="否" :value="0"></el-option>
          <el-option label="是" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物联网卡厂商" prop="cardType" style="position: relative" v-if="isAuth('simWk:show')">
        <el-select v-model="dataForm.cardType" placeholder="请选择" style="width: 100%">
          <el-option label="无" :value="null"></el-option>
          <el-option label="华商物联" :value="0"></el-option>
          <el-option label="齐犇物联" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物联网卡号" prop="msisdn" style="position: relative">
        <el-input v-model="dataForm.msisdn" placeholder="物联网卡号"></el-input>
        <el-button type="primary" style="position: absolute;right: 0" @click="msisdnBtn">查询</el-button>
      </el-form-item>
      <el-form-item label="三方编码" prop="thirdCode">
        <el-input v-model="dataForm.thirdCode" placeholder="三方编码"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input v-model="dataForm.note" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { isAuth } from "@/utils";
export default {
  data() {
    return {
      inputValue: '',
      visible: false,
      disAble: false,
      poiOption: [],
      typeOption: [],
      enumOption: [],
      noticeOption: [
        { 'label': '开启', 'value': 0 },
        { 'label': '关闭', 'value': 1 }
      ],
      dataForm: {
        id: 0,
        uniqueCode: '',
        thirdCode: '',
        type: '',
        name: '',
        poiId: '',
        status: '',
        note: '',
        dataStatus: '',
        createTime: '',
        updateTime: '',
        sort: '',
        hasStartNotify: '',
        lastNotifyInfo: '',
        lastUploadTime: '',
        longitude: '',
        latitude: '',
        videoUrl: '',
        deviceType:'',
        lastExTime: '',
        noticeEnable: '',
        msisdn: '',
        pushParent:0,
        cardType: '',
        warrantyTime: '',
        numberInput: 0,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        }
      },
      dataRule: {
        uniqueCode: [
          { required: true, message: '唯一编码不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '机器型号类型不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        poiId: [
          { required: true, message: 'POI ID不能为空', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '设备状态不能为空', trigger: 'blur' }
        ],
      },
      flag: '',
    }
  },
  created() {

  },
  methods: {
    init(id) {
      this.getDeviceTypeOption()
      this.getDeviceStatusOption()
      this.getPoiOption()
      this.poiOption = []
      this.typeOption = []
      this.enumOption = []
      this.dataForm = {}
      //根据传来id的值，区分新增、修改
      if (id) {//修改
        this.disAble = true
        this.dataForm.id = id
        //获取id设备的信息
        this.$nextTick(() => {
          this.$http({
            url: this.$http.adornUrl("/device/list"),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              id: id
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
              if (data.data.rows[0].manualName != null && data.data.rows[0].manualName != ''){
                this.dataForm.type = data.data.rows[0].manualName 
                this.dataForm.numberInput = data.data.rows[0].manualInput
              }else{
                this.dataForm.numberInput = data.data.rows[0].manualInput 
              }
            }
          })
        })
      } else {//新增
        //情况form表单里的值
        this.disAble = false
        this.dataForm.id = null
        this.dataForm.pushParent = 0; 
      }
      this.visible = true
    },
    // 判断机型型号是否手输
    handleInput(val){
      if (val.length >= 1){
        this.dataForm.numberInput = 1;
      }else{
        this.dataForm.numberInput = 0;
      } 
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid || this.flag == false) {
          console.log(this.dataForm.numberInput) 
          this.$http({
            url: this.$http.adornUrl(`/device/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || null,
              'uniqueCode': this.dataForm.uniqueCode,
              'thirdCode': this.dataForm.thirdCode,
              'type': this.dataForm.numberInput == 1 ? '' : this.dataForm.type,
              'deviceType': this.dataForm.deviceType,
              'name': this.dataForm.name,
              'poiId': this.dataForm.poiId,
              'status': this.dataForm.status,
              'note': this.dataForm.note,
              'videoUrl': this.dataForm.videoUrl,
              'noticeEnable': this.dataForm.noticeEnable,
              'msisdn': this.dataForm.msisdn,
              'pushParent': this.dataForm.pushParent,

              'manualInput': this.dataForm.numberInput,
              'manualName': this.dataForm.type,

              'cardType': this.dataForm.cardType,
              'warrantyTime': this.dataForm.warrantyTime
            })
          }).then(({ data }) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    //获取机器型号
    getDeviceTypeOption() {
      this.$http({
        url: this.$http.adornUrl("/configDeviceType/option"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.typeOption = data.data.typeOption
        }
      })
    },
    //获取设备状态
    getDeviceStatusOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/2"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.enumOption = data.data.enumOption
        }
      })
    },
    //获取点位
    getPoiOption() {
      this.$http({
        url: this.$http.adornUrl("/poi/option"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.poiOption = data.data.poiOption
        }
      })
    },
    //  物联网卡号查询
    msisdnBtn() {
      this.$http({
        url: this.$http.adornUrl("/sim/selectDeviceSim/"),
        method: 'get',
        params: this.$http.adornParams({
          'msisdn': this.dataForm.msisdn,
          'cardType': this.dataForm.cardType,
        })
      }).then(({ data }) => {
        if (data && data.code === 200) {
          this.flag = data.data.flag
          if (data.data.flag == true) {
            this.$message({
              message: '物联网卡已存在，不可创建',
              type: 'warning',
              duration: 2000,
            })
          } else {
            this.$message({
              message: '物联网卡不存在，可创建',
              type: 'success',
              duration: 2000,
            })
          }
        } else {
          this.$message({
            message: data.msg,
            type: 'error',
            duration: 2000,
          })
        }
      })
    },

    // 
    filterMath(query){ 
      if (query !== ''){
        this.poiOption = this.poiOption.filter(item => {
          return item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1;
        });
      }else {
        this.getPoiOption()
      }
    },
    //权限
    isAuth(key) {
      return isAuth(key)
    },
  }
}
</script>
<style>
.dianwei:nth-child(2){
  margin-top: 42px;
}
</style>


// WEBPACK FOOTER //
// src/pages/admincenter/device-add-or-update.vue